import { TOUCH } from '../vm/chips'

// 검토 대기의 조작 칩 — 그 자리에서 끝내는 화면의 칩이라 VM 화면의 조작 칩(`vm/chips.ts`)과
// 달리 대문자로 세우지 않는다. 같은 조작을 검토 대기와 VM 상세가 나눠 쓰기도 해서
// (보존 기한의 파기·되살리기) 문자열은 여기 한 곳에만 있다 — 화면마다 적으면 칩 크기가 갈라지고,
// 좁은 화면에서 커지는 `TOUCH` 가 한쪽에만 빠진다.
export const CHIP = `rounded border px-1.5 py-px text-[10px] tracking-[0.08em] disabled:opacity-50 ${TOUCH}`
export const CHIP_PLAIN = `${CHIP} border-border text-muted-foreground hover:text-foreground`
export const CHIP_DANGER = `${CHIP} border-danger/35 text-danger-ink hover:bg-danger/8`
export const CHIP_BRAND = `${CHIP} border-brand/40 text-brand hover:bg-brand/8`
